var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("任务管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "pageTab" }, [
          _c("div", { staticClass: "title" }, [_vm._v("任务详情")]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("编号：")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.detail.jobNo))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("发布人：")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.taskDetail.creatorName))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("创建时间：")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.detail.gmtCreate))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("发布范围：")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.taskDetail.rangeName))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("人数：")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.taskDetail.readiesNum))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("任务地址：")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.taskDetail.address))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("订单状态：")]),
            _vm._v(" "),
            _vm.taskDetail.status == 0
              ? _c("div", [_vm._v("已取消")])
              : _vm._e(),
            _vm._v(" "),
            _vm.taskDetail.status == 1
              ? _c("div", [_vm._v("待发布")])
              : _vm._e(),
            _vm._v(" "),
            _vm.taskDetail.status == 2
              ? _c("div", [_vm._v("待发布")])
              : _vm._e(),
            _vm._v(" "),
            _vm.taskDetail.status == 3
              ? _c("div", [_vm._v("待实做")])
              : _vm._e(),
            _vm._v(" "),
            _vm.taskDetail.status == 4
              ? _c("div", [_vm._v("实做中")])
              : _vm._e(),
            _vm._v(" "),
            _vm.taskDetail.status == 5
              ? _c("div", [_vm._v("已完成")])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("发布时间：")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.taskDetail.actionAt))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("需求人数：")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.taskDetail.membersNum))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("任务单价：")]),
            _vm._v(" "),
            _c("div", [_vm._v("￥" + _vm._s(_vm.taskDetail.unitPrice))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("任务金额：")]),
            _vm._v(" "),
            _c("div", [_vm._v("￥" + _vm._s(_vm.taskDetail.price))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v("违约详情")]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("违约编号：")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.detail.violateLogNo))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("违约人：")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.detail.memberName))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("违约事项：")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.detail.matterMemo))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("违约时间：")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.detail.violateAt))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("触发规则编号：")]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.detail.violateRuleId))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("违约金额：")]),
            _vm._v(" "),
            _c("div", [_vm._v("￥" + _vm._s(_vm.detail.violateAmount))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [
              _vm._v("第三方支付流水号："),
            ]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.detail.paymentOrder))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("支付方式：")]),
            _vm._v(" "),
            _vm.detail.channelType == 0
              ? _c("div", [_vm._v("钱包")])
              : _vm._e(),
            _vm._v(" "),
            _vm.detail.channelType == 1
              ? _c("div", [_vm._v("对公转账")])
              : _vm._e(),
            _vm._v(" "),
            _vm.detail.channelType == 2
              ? _c("div", [_vm._v("银行卡")])
              : _vm._e(),
            _vm._v(" "),
            _vm.detail.channelType == 3
              ? _c("div", [_vm._v("支付宝")])
              : _vm._e(),
            _vm._v(" "),
            _vm.detail.channelType == 4
              ? _c("div", [_vm._v("微信")])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "infoItem" }, [
            _c("div", { staticClass: "infoTitle" }, [_vm._v("支付状态：")]),
            _vm._v(" "),
            _c("div", [
              _vm._v(_vm._s(_vm.detail.status == 0 ? "待支付" : "已支付")),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }